
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
<h1>{`Naming`}</h1>
<p>{`Follow React standards.`}</p>
<pre><code parentName="pre" {...{}}>{`// - PascalCase components
// - camelCase props
<Component fooBar="value" />
`}</code></pre>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;